import { TOOL_LIST_COPY } from '../agents-copy';
import styles from './ToolListPage.module.css';
import type { ToolListFilter } from './useToolList';

interface ToolStatusFilterProps {
  value: ToolListFilter;
  onChange: (filter: ToolListFilter) => void;
}

const FILTERS: ToolListFilter[] = ['active', 'inactive', 'all'];

export const ToolStatusFilter = ({ value, onChange }: ToolStatusFilterProps) => (
  <div className={styles.statusFilter} role="group" aria-label={TOOL_LIST_COPY.filterLabel}>
    {FILTERS.map(filter => (
      <button
        key={filter}
        type="button"
        aria-pressed={value === filter}
        onClick={() => onChange(filter)}>
        {TOOL_LIST_COPY.filters[filter]}
      </button>
    ))}
  </div>
);
